// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__jlYio","modal-footer":"style_modal-footer__pB5uG","modal-body":"style_modal-body__V6UGJ"};